import { render, staticRenderFns } from "./servicePay.vue?vue&type=template&id=79a68810&"
import script from "./servicePay.vue?vue&type=script&lang=js&"
export * from "./servicePay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports